import React from "react";
import "./WelocateToolbox.css";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ConnectWithAgentModal from "./modals/ConnectWithAgentModal";

const tools = [
  { icon: <CalculateOutlinedIcon />, label: "Calculate buying costs" },
  {
    icon: <PersonAddAlt1OutlinedIcon />,
    label: "Connect with an estate agent",
    modal: ConnectWithAgentModal,
  },
  { icon: <ApartmentOutlinedIcon />, label: "Order a building report" },
  { icon: <ArticleOutlinedIcon />, label: "Order an appraisal" },
];

const WelocateToolbox = () => {
  const [connectAgentModalVisible, setConnectAgentModalVisible] =
    React.useState(false);

  return (
    <div className="wl-toolbox">
      <ConnectWithAgentModal visible={connectAgentModalVisible} setVisible={setConnectAgentModalVisible} />

      <p className="wl-toolbox-title">TOOLS &amp; SERVICES</p>
      <ul className="wl-toolbox-list">
        {tools.map((tool, i) => (
          <li
            key={i}
            className="wl-toolbox-item"
            onClick={() => {
              if (tool.modal) {
                setConnectAgentModalVisible(true);
              }
            }}
          >
            <span className="wl-toolbox-icon">{tool.icon}</span>
            <span className="wl-toolbox-label">{tool.label}</span>
            <ArrowForwardIosIcon className="wl-toolbox-arrow" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WelocateToolbox;
